import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { blockedToastConfig } from '../customers/components/blocked-toast/blocked-toast.component'
import { customerFaqsComponent } from './containers/faqs/faqs.component'
import { customerFaqsState } from './faqs.states'

const faqsModule = {
  components: { customerFaqsComponent },
  states: [customerFaqsState],
  configBlocks: [blockedToastConfig],
}

loadNg1Module(ngmodule, faqsModule)



// WEBPACK FOOTER //
// ./app/faqs/faqs.module.js